import config from '../../config/config';
import DefaultApiLimit from '../../config/defaultLimit';
import { RequestFirmwareJobs } from '../../interface/firmware-jobs.interface';

import getRequest from './base/get';

/**
 * API service for Firmware jobs management.
 */
const firmwareJobsApi = {
  /**
   * Fetch the firmware jobs list with pagination.
   * @param {RequestFirmwareJobs} query - The query parameters.
   * @returns {Promise<any>} A promise that resolves with the firmware jobs list.
   */
  fetchFirmwareJobs: (query: RequestFirmwareJobs = {}): Promise<any> => {
    const parameters = { ...query, limit: query?.limit || DefaultApiLimit.limit };
    const url = `${config.devices.ChargersApiUrl}api/admin/v1/firmware/jobs`;
    return getRequest(url, {
      ...parameters,
    });
  },
};

export default firmwareJobsApi;
